import React from "react";

import Divider from "@mui/material/Divider";

import { colors } from "components";

export interface IVerticalHr {
  border?: string;
  height?: string;
  paddingLeft?: string;
  paddingRight?: string;
}

export const VerticalHr: React.FC<IVerticalHr> = ({
  border = "1px",
  height = "14px",
}) => {
  return (
    <Divider
      orientation="vertical"
      sx={{
        height: { height },
        width: "6px",
        borderLeft: `${border} solid ${colors.default_base_grey}`,
        borderRight: "0px",
      }}
    />
  );
};

export default VerticalHr;
